<template>
    <div component="ProfileButtons" :disabled="!getUserTermsAgreed">
        <div class="holder">
            <nav-button
                v-for="button in getProfileButtons"
                :key="button.key"
                :class="button.cls"
                :to="button.to"
                :icon="button.icon"
                :text="button.text"
                :html="button.html"
                :size="button.size"
                :color="button.color"
                :radius="button.radius"
                :tpos="button.tpos"
                :order="button.key"
            ></nav-button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Mp3Player from '@/components/.global/Mp3Player.vue';

export default {
    name: 'ProfileButtons',

    computed: {
        ...mapGetters(['getIsLoggedIn', 'getActor', 'getProfileButtons', 'getSampleMp3Url', 'getUserTermsAgreed']),
    },

    components: {
        Mp3Player,
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='ProfileButtons'] {
    transition: 0.5s;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    padding: 0 10%;
    z-index: 333;

    @media (max-width: 620px) {
        top: 5%;
        left: 5%;
        width: 90%;
        height: 90%;
    }

    &[disabled] {
        [component] {
            pointer-events: none;
        }
    }

    .holder {
        position: relative;
        width: 100%;
        height: 100%;
    }

    [component='NavButton'][radius='circle'].router-link-exact-active,
    [component='NavButton'][radius='circle'].router-link-active {
        .icon {
            color: @white;
            // background: transparent;
        }

        i {
            border: 2px solid @white;
        }
    }

    [component] {
        position: absolute;
        transform: translate3d(-50%, -0%, 0);
        pointer-events: all;

        .text {
            position: absolute;
            top: 100%;

            @media (max-width: 620px) {
                b {
                    display: none;
                }
            }
        }

        &[tpos='top'] {
            .text {
                top: -16px;
            }
        }

        &[order='0'] {
            top: 0;
            left: 25%;
        }

        &[order='1'] {
            top: 0;
            left: 75%;
        }

        &[order='2'] {
            bottom: 4%;
            left: 5%;
        }

        &[order='3'] {
            bottom: -11%;
            left: 25%;
        }

        &[order='4'] {
            bottom: -17%;
            left: 50%;
        }

        &[order='5'] {
            bottom: -11%;
            left: 75%;
        }

        &[order='6'] {
            bottom: 4%;
            left: 95%;
        }

        @media (max-width: 620px) {
            &[order='0'] {
                left: 23%;
                top: -6%;
            }

            &[order='1'] {
                left: 77%;
                top: -6%;
            }

            &[order='2'] {
                bottom: 8%;
                left: 0;
            }

            &[order='3'] {
                bottom: -9%;
                left: 23%;
            }

            &[order='4'] {
                bottom: -17%;
                left: 50%;
            }

            &[order='5'] {
                bottom: -9%;
                left: 77%;
            }

            &[order='6'] {
                bottom: 8%;
                left: 100%;
            }
        }

        @media (max-height: 660px) {
            &[radius='circle'],
            &[size='big'] {
                // width: 50px;
                // height: 50px;
                // // border: 5px solid white;
            }
        }
    }
}
</style>
